module.exports = __webpack_public_path__ + "images/PagSeguro-f56950.png";